import React from 'react';
import './App.css';
import { variableName } from './variableName';
import MOBILE from './assets/images/DOWNLOAD THE MOBILE APP.png';
import { Image } from 'antd';

function Footer() {


    const goToApp = () => {
        window.open('https://sites.google.com/view/suprabhat-app/home', '_blank', 'noopener,noreferrer');
    }
    return (
        <>
            <footer className='footer' style={
                {
                    bottom: 0,
                    // position: "fixed",
                    // backgroundColor: "#ccc",
                    // color: "white",
                    width: "100%"
                }}>
                <div className='row m-0' style={{
                    fontSize: 18,
                    fontWeight: 700,
                }}>
                    <div className='col-md-3 pl-5 offset-md-1'>
                        <p>
                            {variableName.outer.footerName}<br />
                            {variableName.outer.address.map((addressLine, index) => (
                                <span key={index}>{addressLine}<br /></span>
                            ))}
                        </p>

                    </div>
                    <div className='col-md-4 d-flex justify-content-center  '>
                        <img src={MOBILE}
                            style={{
                                height: "auto",
                                width: "400px",
                                maxHeight: 150,
                                objectFit: "stretch"
                            }} className='R' alt="" onClick={goToApp} role='button' />

                    </div>
                    <div className='col-md-4'>
                        <div className='row'>
                            <div className=' col-md-3'>
                            </div>
                            <div className=' col-md-8'>
                                <div className='row'>
                                    <div className=' col-md-12  '>
                                        <ul style={{ listStyle: "none" }}>
                                            {variableName.outer.right.liContent.map((item, index) => (
                                                <li key={index}>{item}</li>
                                            ))}
                                        </ul>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div className='text-center  ' style={{ paddingTop: 10 }}>
                    <p className="m-0" style={{ fontSize: 12 }}>By <a href='https://relysoft.in/' rel="noopener noreferrer" target='_blank'>Reliable Software, Goa</a>. </p>
                </div>
            </footer>
        </>
    )
}
export default Footer;